// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3NHQ5","title":"ClientInsurance_title__3EWvj","itemText":"ClientInsurance_itemText__1YI3p"};